module.exports = __webpack_public_path__ + "assets/student-emil.060b6431.jpg";


//////////////////
// WEBPACK FOOTER
// ../source/assets/homepage/student-emil.jpg
// module id = 1639
// module chunks = 10